const formatKeys = {
    number: 'number',
    percent: 'percent',
    currency: 'currency',
    date: 'date',
    quarter: 'quarter',
    boolean: 'boolean',
    array: 'array',
    string: 'string',
    ids: 'ids'
};

const metrics = {
    GroupBy: {
        titleKey: 'Referrer',
        isSortable: true,
        Referrer: {
            format: formatKeys.ids,
            title: 'Referrer'
        },
        Referral: {
            format: formatKeys.ids,
            title: 'Referral'
        },
        OfferReferrer: {
            format: formatKeys.ids,
            title: 'OfferReferrer'
        },
        AdvertiserReferrer: {
            format: formatKeys.ids,
            title: 'AdvertiserReferrer'
        }
    },
    ReferralId: {
        format: formatKeys.string,
        titleKey: 'Number of referrals',
        visible: true,
        isSortable: false
    },
    TurnoverCount: {
        format: formatKeys.number,
        titleKey: 'Quantity',
        visible: true,
        isSortable: false
    },
    TurnoverAmount: {
        format: formatKeys.currency,
        titleKey: 'Amount',
        visible: true,
        isSortable: false
    },
    TurnoverBetCount: {
        format: formatKeys.number,
        titleKey: 'Quantity',
        visible: true,
        isSortable: false
    },
    TurnoverBetAmount: {
        format: formatKeys.currency,
        titleKey: 'Amount',
        visible: true,
        isSortable: false
    },
    RegistrationCount: {
        format: formatKeys.number,
        titleKey: 'Quantity',
        visible: false,
        isSortable: false
    },
    FTDCount: {
        format: formatKeys.number,
        titleKey: 'Quantity',
        visible: true,
        isSortable: false
    },
    FTDAmount: {
        format: formatKeys.currency,
        titleKey: 'Amount',
        visible: true,
        isSortable: false
    },
    DepositCount: {
        format: formatKeys.number,
        titleKey: 'Quantity',
        visible: false,
        isSortable: false
    },
    DepositAmount: {
        format: formatKeys.currency,
        titleKey: 'Amount',
        visible: false,
        isSortable: false
    },
    WinCount: {
        format: formatKeys.number,
        titleKey: 'Quantity',
        visible: false,
        isSortable: false
    },
    WinAmount: {
        format: formatKeys.currency,
        titleKey: 'Amount',
        visible: false,
        isSortable: false
    },
    BetCount: {
        format: formatKeys.number,
        titleKey: 'Quantity',
        visible: true,
        isSortable: false
    },
    BetAmount: {
        format: formatKeys.currency,
        titleKey: 'Amount',
        visible: true,
        isSortable: false
    }
};

const treeMetric = [
    [
        {
            config: {
                key: 'groups',
                metrics: ['GroupBy']
            }
        },
        {
            config: {
                key: 'Referrals',
                metrics: ['ReferralId']
            }
        },
        {
            config: {
                key: 'CompletedGoalsDeposit',
                metrics: ['TurnoverCount', 'TurnoverAmount']
            }
        },
        {
            config: {
                key: 'CompletedGoalsBet',
                metrics: ['TurnoverBetCount', 'TurnoverBetAmount']
            }
        },
        {
            config: {
                key: 'regs',
                metrics: ['RegistrationCount']
            }
        },
        {
            config: {
                key: 'FTDs',
                metrics: ['FTDCount', 'FTDAmount']
            }
        },
        {
            config: {
                key: 'Deposits',
                metrics: ['DepositCount', 'DepositAmount']
            }
        },
        {
            config: {
                key: 'Wins',
                metrics: ['WinCount', 'WinAmount']
            }
        },
        {
            config: {
                key: 'Bets',
                metrics: ['BetCount', 'BetAmount']
            }
        }
    ]
];

export {
    formatKeys,
    metrics,
    treeMetric
};
